import { render, staticRenderFns } from "./altaPaciente.vue?vue&type=template&id=18b564a1&scoped=true"
import script from "./altaPaciente.vue?vue&type=script&lang=js"
export * from "./altaPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b564a1",
  null
  
)

export default component.exports